var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup219(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.485,
    height: 20,
    viewBox: "0 0 16.485 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(989.227 -33.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3425",
    "data-name": "Path 3425",
    d: "M-979.534,35.432c.615,0,.615,0,.771-.447a1.985,1.985,0,0,1,1.941-1.353,1.961,1.961,0,0,1,1.837,1.486,2.075,2.075,0,0,1-.128,1.358.312.312,0,0,0,.115.437,5.645,5.645,0,0,1,2.2,3.7,6.367,6.367,0,0,1-.364,3.1,13.6,13.6,0,0,0-.753,3.067,7.116,7.116,0,0,0,.182,2.959,1.651,1.651,0,0,1-.018.819,8.439,8.439,0,0,1-.359,1.019.638.638,0,0,1-.893.42q-3.026-1.086-6.05-2.174l-7.664-2.751a.647.647,0,0,1-.443-.93c.118-.326.238-.652.355-.978a1.191,1.191,0,0,1,.506-.65,6.071,6.071,0,0,0,1.855-1.877,14.957,14.957,0,0,0,1.616-3.292,5.881,5.881,0,0,1,2.784-3.275A5.656,5.656,0,0,1-979.534,35.432Z",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3426",
    "data-name": "Path 3426",
    d: "M-878.444,434.833a2.238,2.238,0,0,1-2-1.2,2.112,2.112,0,0,1,.106-2.283.422.422,0,0,1,.546-.2q1.625.573,3.245,1.159a.47.47,0,0,1,.311.555,2.27,2.27,0,0,1-1.837,1.917C-878.206,434.806-878.335,434.819-878.444,434.833Z",
    transform: "translate(-104.048 -381.203)",
    fill: "#d10a11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup219);
export default __webpack_public_path__ + "static/media/Group 219.7a26df28e842f798ab69d72ad06257b3.svg";
export { ForwardRef as ReactComponent };